import styled from 'styled-components';
import Input from 'antd/lib/input';

const CustomInput = styled(Input)`
  padding: 4px 8px;
  font-size: 13px;
`;

export default CustomInput;
